import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TARIFAS, formatARS } from "../../lib/site";
import { useLivePrices, priceOf } from "../../lib/livePrices";
import { FadeUp, MaskLines, Eyebrow } from "../site/Motion";

export const Tarifas = () => {
  const prices = useLivePrices();
  return (
  <section data-testid="home-tarifas" className="bg-[var(--paper)] py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Eyebrow>Tarifas desde</Eyebrow>
      <h2 className="mt-5 font-display text-4xl md:text-6xl"><MaskLines inView lines={["Tu butaca,", "tu precio."]} /></h2>
      <p className="mt-5 max-w-lg text-[var(--muted-ink)]">Precios de referencia por tramo. El valor final lo ves al elegir horario y butaca.</p>
      <div className="mt-12 grid gap-4 md:grid-cols-3">
        {TARIFAS.map((t, i) => (
          <FadeUp key={i} delay={i * 0.1}>
            <div data-testid={`tarifa-card-${i}`} className={`ticket-cut group flex h-full flex-col rounded-[28px] p-8 transition-transform duration-500 hover:-translate-y-2 ${t.featured ? "bg-[var(--forest)] text-white" : "bg-white"}`}>
              <p className={`font-mono text-[11px] uppercase tracking-[0.22em] ${t.featured ? "text-[var(--lime)]" : "text-[var(--forest)]"}`}>{t.tag}</p>
              <p className="mt-4 text-lg font-semibold">{t.route}</p>
              <div className={`my-8 border-t border-dashed ${t.featured ? "border-white/30" : "border-black/15"}`} />
              <p className={`text-sm ${t.featured ? "text-white/80" : "text-[var(--muted-ink)]"}`}>Desde</p>
              <p data-testid={`tarifa-price-${i}`} className="font-display text-5xl md:text-6xl">{(() => { const [orig, dest] = t.route.split(" → "); const p = priceOf(prices, orig, dest, t.tag.startsWith("Semicama") ? 0 : 1); return p ? formatARS(p) : t.price; })()}</p>
              <p className={`mt-3 text-sm ${t.featured ? "text-white/80" : "text-[var(--muted-ink)]"}`}>Reclinación {t.recline}</p>
              <Link to={`/pasajes?o=${encodeURIComponent(t.route.split(" →")[0])}&d=${encodeURIComponent(t.route.split("→ ")[1])}`} data-testid={`tarifa-cta-${i}`} className={`mt-8 inline-flex items-center gap-2 self-start rounded-full px-5 py-3 text-sm font-bold transition-[background-color,color] duration-300 ${t.featured ? "bg-[var(--lime)] text-[var(--ink)] hover:bg-white" : "bg-[var(--ink)] text-white hover:bg-[var(--forest)]"}`}>
                Ver horarios <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
  );
};
